import { createFileRoute } from '@tanstack/react-router';

import { PEOPLE_PAGE_ANCHOR } from '@/features/(insight)/people/people-constants';
import { PeoplePage } from '@/features/(insight)/people/index';
import z from 'zod';

export const Route = createFileRoute('/workspace/$workspaceId/insight/people')({
  validateSearch: z.object({
    anchor: z
      .enum([
        PEOPLE_PAGE_ANCHOR.AGE_TABLE,
        PEOPLE_PAGE_ANCHOR.GENDER_TABLE,
        PEOPLE_PAGE_ANCHOR.LOCATION_TABLE,
        PEOPLE_PAGE_ANCHOR.PEOPLE_TABLE,
        PEOPLE_PAGE_ANCHOR.RACE_TABLE,
      ])
      .optional(),
  }),
  component: PeoplePage,
});
